export const APIList = {
  getAllCompanies: "insurance_company/getByPolicyId?policyTypeId=3030b68f-82e9-4dfb-b2b8-82b743d0692a",
  createUser: "user/createUser",
  verifyOtp: "user/verifyOtp",
  getClaimFilingData: "filtration/getUserClaimFiling",
  uploadDocument: "filtration/claimfiling/documentupload/",
  currentClaimForm: "filtration/claimFormDataV2/",
  updateForm: "filtration/updateFormV2/",
  userProfile: "user/profile",
  getClaimFileDocumentList: "filtration/claimFileDocumentList/",
  getBankFromIFSC: "filtration/ifscOfBank/",
  getDisclaimer: "filtration/disclaimer",
  getTransaction: "transaction/hcr",
  getOnEmail: "filtration/claimFileMailing",
  getStateFromPincode: "filtration/pinCodeDetails",
  getlumpSumList: "filtration/claimFileLumpSumList",
  downloadClaimForm: "hcr/downloadClaimForm",
  preFillData: "policy/preFillData/",
  getPartnerData: "/api/v1/user/getPartnerDetails",
  couponCheck: "coupon/check"
};
